import { render } from "./FacultyMentoring&CommitmentDialog.vue?vue&type=template&id=727e429b"
import script from "./FacultyMentoring&CommitmentDialog.vue?vue&type=script&lang=js"
export * from "./FacultyMentoring&CommitmentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__